import styled from 'styled-components';

const styledTab = styled.div`
    padding-top:20px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
        padding:0px;
        };
    ul{
        margin:0px;
        padding:0px;
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
            margin:0px 30px;
        };
        @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
            text-align: center;
        };
        li{
            list-style: none;
            display: inline-block;
            padding: 15px 30px;
            position: relative;
            font-size: 16px !important;
            margin-bottom: 0px !important;
            background: ${(props) => props.theme.lightWhite};
            margin-right: 10px;
            border-radius: 10px 10px 0px 0px;
            @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
            width: 100%;
            };
            &.active{
                background:${(props) => props.theme.whiteColor};
                color: #ff0000;
                a{
                    color: #ff0000;
                }
            }
            a{
                text-decoration:none;
                color: ${(props) => props.theme.secondaryColor};
                text-transform:uppercase;
            }
        }
    }
`;

export default styledTab;



// WEBPACK FOOTER //
// client/components/TabMenu/styledTabMenu.js